import { yup } from '@guiker/yup-util'

import { SupportedCountries } from '../../../entity'

export const regionQueryparamsSchema = yup.object({
  region: yup.string().oneOf(Object.values(SupportedCountries)).optional(),
})

export type RegionQueryparamsSchema = yup.InferType<typeof regionQueryparamsSchema>
